import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
// 上拉加载更多列表
import api from '@/api';
import pickerOption from './pickerOption.js';
export default {
  mixins: [pickerOption],
  data: function data() {
    return {
      // 总条数
      statusList: [{
        lable: '正常',
        value: 1
      }, {
        lable: '禁用',
        value: 2
      }, {
        lable: '审核中',
        value: 3
      }],
      total: 0,
      tableData: [],
      // 列表请求方法
      pagingReqFn: null,
      // 请求中存放列表的字段
      pagingReqValue: 'data',
      // 请求或搜索存放请求参数
      paramsData: {
        page_size: 10,
        page: 1
      },
      reqLoading: false,
      columns: []
    };
  },
  methods: {
    // 公用分页
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.getList();
    },

    /**
     * 请求列表方法
     * @param page 页码
     * @param pagingCallback 回调函数
     * **/
    getList: function getList() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var pagingCallback = arguments.length > 1 ? arguments[1] : undefined;
      this.paramsData.page = page;
      this.paramsData.appid ? this.paramsData.isSearch = true : this.paramsData.isSearch = false;

      if (!this.pagingReqFn) {
        console.error('请传入请求函数');
        return false;
      }

      this.reqLoading = true;
      var appid = '';

      if (Array.isArray(this.paramsData.appid)) {
        appid = this.paramsData.appid.join(",");
      } else {
        appid = this.paramsData.appid;
      }

      api[this.pagingReqFn](_objectSpread(_objectSpread({}, this.paramsData), {}, {
        appid: appid
      })).then(function (res) {
        if (res.status == 200) {
          if (page > 1 && !res.data.data.length) {
            _this.getList(page - 1);
          } else {
            var data = res.data;
            _this.total = data.total || 0;
            _this.tableData = _this.pagingReqValue ? data[_this.pagingReqValue] || [] : data || [];
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportData: function exportData() {
      var _this2 = this;

      api[this.pagingReqFn](_objectSpread(_objectSpread({}, this.paramsData), {}, {
        page: 1,
        page_size: this.total + 10
      })).then(function (res) {
        if (res.status == 200) {
          _this2.expData = res.data.data;

          _this2.expData.forEach(function (item) {
            item.create_time = item.create_time ? _this2.$times.timestampToTime(item.create_time) : '/';
          });

          _this2.$export.excel({
            columns: _this2.columns,
            data: _this2.expData,
            title: _this2.$route.meta.title
          });
        }
      });
    }
  }
};